import restArguments from './restArguments.js';
import unzip from './unzip.js';

// Zip together multiple lists into a single array -- elements that share
// an index go together.
export default restArguments(unzip);



//////////////////
// WEBPACK FOOTER
// ./~/underscore/modules/zip.js
// module id = 1055
// module chunks = 0